import { createTheme } from "@mantine/core";
import { mantineComponentsSurfaces } from "./theme/mantineComponentsSurfaces";
import { mantineComponentsChrome } from "./theme/mantineComponentsChrome";

export { UI_FIELD_RADIUS_PX } from "./theme/dashboardTagTokens";

const theme = createTheme({
  primaryColor: "brand",
  primaryShade: 6,
  black: "#0D0D27",
  colors: {
    brand: [
      "#eff1ff",
      "#dfe3ff",
      "#c4cbff",
      "#a7b0ff",
      "#8c97ff",
      "#7280ff",
      "#5363FF",
      "#4553dc",
      "#3945b8",
      "#2e3896",
    ],
    gray: [
      "#F2F2F4",
      "#ebebee",
      "#E3E3E5",
      "#d7d9de",
      "#c2c6cf",
      "#9ca3b1",
      "#6B7383",
      "#515a6b",
      "#3a4253",
      "#252b3a",
    ],
  },
  fontSmoothing: true,
  fontFamily: "Inter",
  headings: { fontFamily: "Inter Tight" },
  components: {
    ...mantineComponentsSurfaces,
    ...mantineComponentsChrome,
  },
});

export default theme;
